import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class Step410647Meta extends BaseModel {
  haveInstitutionsBeenNotified: boolean | null;

  constructor(model: Partial<Step410647Meta> = {}) {
    super();

    this.haveInstitutionsBeenNotified = model.haveInstitutionsBeenNotified ?? null;
  }
}
